'use strict';/* global define:false */define('modules/download/config',['require','./states/admin_download/index'],function(require){'use strict';// @ngInject
config.$inject = ["$stateProvider"];
function config($stateProvider){$stateProvider.state('app.admin.download',require('./states/admin_download/index'));}return config;});
